import React, { useState, useEffect } from "react";
import { useTheme } from "../components/ThemeContext";
import { Form, Button, Row, Col, Dropdown, FormControl } from "react-bootstrap";
import "../App.css";
import NavMenu from "../components/NavMenu";
import axios from "axios";
import TextareaAutosize from "react-textarea-autosize";
import { IoArrowBackSharp } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import { FaTrashAlt } from "react-icons/fa";

function EditAppraisalAssessment() {
  const [step, setStep] = useState(1);
  const [selectedValue, setSelectedValue] = useState("Select staff");
  const [staff, setStaff] = useState([]);
  // const [supervisorid, setSupervisorID] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [showStaffDropdown, setShowStaffDropdown] = useState(false);
  const [disabled] = useState(true);
  const [roleId, setRoleId] = useState("");
  const [appraisalType, setAppraisalType] = useState("");
  const [appraisalId, setAppraisalId] = useState("");
  const { isDark } = useTheme();

  const navigate = useNavigate();

  const location = useLocation();
  const staff_id = location.state?.staff_id;
  const { send_id } = location.state || {};

  useEffect(() => {
    if (send_id) {
      fetchDetailTemplate(send_id);
    }
  }, [send_id]);

  const [factors, setFactors] = useState([
    { factor: "", description: "", rating: "5" },
    { factor: "", description: "", rating: "5" },
    { factor: "", description: "", rating: "5" },
  ]);

  const [performances, setPerformances] = useState([
    { description: "", score: "", rating: "5" },
    { description: "", score: "", rating: "5" },
    { description: "", score: "", rating: "5" },
  ]);

  const handleSelectStaff = (eventKey) => {
    const selected = staff.find((s) => String(s.staff_id) === eventKey);
    setSelectedValue(selected?.display_name || "Select staff");
    setShowStaffDropdown(false);
    setSearchTerm("");
  };

  const filteredStaff = staff.filter((s) =>
    s.display_name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const removePerformance = (index) => {
    const updated = [...performances];
    updated.splice(index, 1);
    setPerformances(updated);
  };

  const removefactor = (index) => {
    const updated = [...factors];
    updated.splice(index, 1);
    setFactors(updated);
  };

  // useEffect(() => {
  //   const user = JSON.parse(localStorage.getItem("user"));
  //   if (user?.description) {
  //     setSupervisorID(user.id);
  //   }
  // }, []);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const token = localStorage.getItem("authToken");
        if (!token) {
          throw new Error("No auth token found in localStorage");
        }

        const response = await axios.get(
          `${process.env.REACT_APP_API}/getStaffName`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.data.success) {
          setStaff(response.data.data);
        } else {
          console.error(response.data.message);
        }
      } catch (error) {
        console.error("Error fetching staff data:", error);
      }
    };

    fetchStaff();
  }, []);

  useEffect(() => {
    if (staff.length > 0 && staff_id) {
      const selectedStaff = staff.find(
        (s) => String(s.staff_id) === String(staff_id)
      );
      if (selectedStaff) {
        setSelectedValue(selectedStaff.display_name);
      }
    }
  }, [staff, staff_id]);

  const fetchDetailTemplate = async (send_id) => {
    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      const response = await axios.get(
        `${process.env.REACT_APP_API}/getPAAssessment`,
        {
          params: { send_id: send_id },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        const data = response.data.data;

        if (data.length > 0) {
          const { role_id, type, appraisal_id } = data[0];

          setRoleId(role_id);
          setAppraisalType(type);
          setAppraisalId(appraisal_id);
        }

        const factorItems = data.filter((item) => item.factor !== null);
        const performanceItems = data.filter((item) => item.factor === null);

        setFactors(
          factorItems.map((item) => ({
            id: item.form_id,
            factor: item.factor || "",
            description: item.description || "",
            rating: item.default_rating_scale || "",
            editable: false,
          }))
        );

        setPerformances(
          performanceItems.map((item) => ({
            id: item.form_id,
            description: item.description || "",
            score: item.weight || "",
            rating: item.default_rating_scale || "",
            editable: false,
          }))
        );
      } else {
        console.error("Error fetching PA Assessment:", response.data.message);
      }
    } catch (error) {
      console.error("Error loading detail template:", error);
    }
  };

  const addFactor = () => {
    setFactors([
      ...factors,
      { factor: "", description: "", rating: "5", editable: true },
    ]);
  };

  const addPerformance = () => {
    setPerformances([
      ...performances,
      { description: "", score: "", rating: "5", editable: true },
    ]);
  };

  const handleFactorChange = (index, field, value) => {
    const updated = [...factors];
    updated[index][field] = value;
    setFactors(updated);
  };

  const handlePerformanceChange = (index, field, value) => {
    const updated = [...performances];
    updated[index][field] = value;
    setPerformances(updated);
  };

  const saveAppraisal = async () => {
    const newFactors = factors.filter((f) => f.editable && !f.id);
    const updatedFactors = factors.filter((f) => !f.editable && f.id);

    const newPerformances = performances.filter((p) => p.editable && !p.id);
    const updatedPerformances = performances.filter((p) => !p.editable && p.id);

    const isFactorValid = [...newFactors, ...updatedFactors].every(
      (f) => f.factor.trim() !== "" && f.description.trim() !== "" && f.rating
    );
    const isPerformanceValid = [
      ...newPerformances,
      ...updatedPerformances,
    ].every(
      (p) =>
        p.description.trim() !== "" && p.score && !isNaN(p.score) && p.rating
    );

    if (!isFactorValid || !isPerformanceValid) {
      alert("Please fill all fields (including weight/score) before saving.");
      return;
    }

    const token = localStorage.getItem("authToken");
    if (!token) {
      throw new Error("No auth token found in localStorage");
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}/AppraisalUpdate`,
        {
          staff_id: staff_id,
          role_id: roleId || "",
          type: appraisalType || "",
          appraisal_id: appraisalId || "",
          newFactors,
          updatedFactors,
          newPerformances,
          updatedPerformances,
          send_id: send_id || null,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        try {
          const user = JSON.parse(localStorage.getItem("user"));
          const created_by = user?.id;

          const description = "Appraisal updated";

          if (!send_id) {
            console.warn("No send_id available to save history.");
          } else {
            await axios.post(
              `${process.env.REACT_APP_API}/saveHistory`,
              {
                send_id,
                description,
                created_by,
              },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );
          }
        } catch (historyErr) {
          console.error("Failed to save history:", historyErr);
        }

        alert("Performance Appraisal saved successfully!");
        navigate(-1);
      } else {
        alert("Failed to save appraisal. Please try again.");
      }
    } catch (error) {
      console.error("Error saving appraisal:", error);
      alert("Server error. Please try again later.");
    }
  };

  const deletePerformance = async (form_id, index) => {
    if (!form_id) return;

    const confirmDelete = window.confirm(
      "Are you sure you want to delete this item?"
    );
    if (!confirmDelete) return;

    try {
      const token = localStorage.getItem("authToken");
      if (!token) {
        throw new Error("No auth token found in localStorage");
      }

      const response = await axios.post(
        `${process.env.REACT_APP_API}/deleteUpdateForm`,
        { form_id },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.data.success) {
        const updated = [...performances];
        updated.splice(index, 1);
        setPerformances(updated);
        alert("Deleted successfully!");
      } else {
        alert("Failed to delete. Try again.");
      }
    } catch (error) {
      console.error("Error deleting form:", error);
      alert("Server error during delete.");
    }
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <>
      <NavMenu />
      <div className={`p-4 ${isDark ? "text-light" : "text-dark"}`}>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h5 className="header-title mb-0">
            <Button
              variant={isDark ? "outline-dark" : "outline-light"}
              size="sm"
              onClick={handleBack}
              style={{
                fontSize: "0.9rem",
                color: "#B31E8D",
                border: isDark ? "1px solid #202020" : "1px solid #EAECF0",
              }}
            >
              <IoArrowBackSharp
                style={{
                  marginRight: "5px",
                  color: isDark ? "#fff" : "#B31E8D",
                }}
                size={20}
              />
            </Button>{" "}
            Edit Appraisal Assessment{" "}
          </h5>
        </div>

        <div className="d-flex align-items-center mb-3">
          <label className="me-2 mb-0 fw-bold" style={{ width: "110px" }}>
            Staff name:
          </label>

          <Dropdown
            show={showStaffDropdown}
            onToggle={() =>
              !disabled && setShowStaffDropdown(!showStaffDropdown)
            }
          >
            <Dropdown.Toggle
              variant={isDark ? "dark" : "outline-dark"}
              disabled={disabled}
            >
              {selectedValue}
            </Dropdown.Toggle>

            <Dropdown.Menu style={{ maxHeight: "200px", overflowY: "auto" }}>
              <div className="px-3 py-2">
                <FormControl
                  placeholder="Search staff..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  autoFocus
                  disabled={disabled}
                />
              </div>
              <Dropdown.Divider />
              {filteredStaff.length > 0 ? (
                filteredStaff.map((item) => (
                  <Dropdown.Item
                    key={item.staff_id}
                    eventKey={String(item.staff_id)}
                    onClick={() => handleSelectStaff(String(item.staff_id))}
                    disabled={disabled}
                  >
                    {item.display_name}
                  </Dropdown.Item>
                ))
              ) : (
                <Dropdown.Item disabled>No matching names</Dropdown.Item>
              )}
            </Dropdown.Menu>
          </Dropdown>
        </div>

        <div className="stepper mb-4 d-flex align-items-center gap-2">
          {[1, 2, 3].map((num) => (
            <React.Fragment key={num}>
              <div
                className={`step ${step === num ? "active" : ""} ${
                  isDark ? "step-dark" : "step-light"
                }`}
                onClick={() => setStep(num)}
                style={{ cursor: "pointer" }}
              >
                {num}
              </div>
              {num < 3 && (
                <div
                  className={`line ${isDark ? "line-dark" : "line-light"}`}
                />
              )}
            </React.Fragment>
          ))}
        </div>

        {step === 1 && (
          <>
            <p className="fw-semibold">Part I: COMPETENCIES</p>
            <Row>
              <Col md={3}>
                <p>Factor</p>
              </Col>
              <Col md={6}>
                <p>Description</p>
              </Col>
              <Col md={3}>
                <p>Rating</p>
              </Col>
            </Row>
            {factors.map((factor, idx) => (
              <Row key={idx} className="mb-3">
                <Col md={3}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder={`Factor #${idx + 1}`}
                    value={factor.factor}
                    onChange={(e) =>
                      handleFactorChange(idx, "factor", e.target.value)
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                    // readOnly={!factor.editable}
                  />
                </Col>
                <Col md={6}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder="Description"
                    value={factor.description}
                    onChange={(e) =>
                      handleFactorChange(idx, "description", e.target.value)
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                    // readOnly={!factor.editable}
                  />
                </Col>
                <Col md={2}>
                  <Form.Select
                    value={factor.rating}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handleFactorChange(idx, "rating", e.target.value)
                    }
                    // disabled={!factor.editable}
                    disabled={disabled}
                  >
                    <option>Rating</option>
                    <option>5</option>
                    <option>4</option>
                  </Form.Select>
                </Col>
                 <Col md={1} className="pt-2">
                
                    <FaTrashAlt
                      onClick={() => removefactor(idx)}
                      style={{ cursor: "pointer", color: "#dc3545" }}
                      title="Remove unsaved item"
                    />
                 
                </Col>
              </Row>
            ))}
            <div className="d-flex gap-3 mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={addFactor}
              >
                Add Factor
              </Button>
              <Button
                variant="outline-light"
                onClick={() => setStep(2)}
                style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
              >
                Next Page
              </Button>
            </div>
          </>
        )}

        {step === 2 && (
          <>
            <p className="fw-semibold">
              Part II: SPECIFIC PERFORMANCE OBJECTIVES
            </p>
            <Row>
              <Col md={7}>
                <p>Description of Work Targets and Actual Results Attained</p>
              </Col>
              <Col md={2}>
                <p>Weight</p>
              </Col>
              <Col md={3}>
                <p>Rating</p>
              </Col>
            </Row>
            {performances.map((perf, idx) => (
              <Row key={idx} className="mb-3">
                <Col md={7}>
                  <TextareaAutosize
                    className="form-control"
                    placeholder="Key Objectives"
                    value={perf.description}
                    onChange={(e) =>
                      handlePerformanceChange(
                        idx,
                        "description",
                        e.target.value
                      )
                    }
                    minRows={2}
                    maxRows={10}
                    style={{
                      backgroundColor: isDark ? "#282828" : "#fff",
                      color: isDark ? "#fff" : "#000",
                      borderColor: isDark ? "#444" : "#ced4da",
                    }}
                    // readOnly={!perf.editable}
                  />
                </Col>
                <Col md={2}>
                  <Form.Select
                    value={perf.score}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handlePerformanceChange(idx, "score", e.target.value)
                    }
                  >
                    <option>Weight</option>
                    <option>1</option>
                    <option>2</option>
                    <option>3</option>
                  </Form.Select>
                </Col>
                <Col md={2}>
                  <Form.Select
                    value={perf.rating}
                    className={
                      isDark ? "bg-dark text-light border-secondary" : ""
                    }
                    onChange={(e) =>
                      handlePerformanceChange(idx, "rating", e.target.value)
                    }
                    // disabled={!perf.editable}
                    disabled={disabled}
                  >
                    <option>Rating</option>
                    <option>5</option>
                    <option>4</option>
                  </Form.Select>
                </Col>
                <Col md={1} className="pt-2">
                  {perf.description.trim() === "" && perf.score === "" ? (
                    <FaTrashAlt
                      onClick={() => removePerformance(idx)}
                      style={{ cursor: "pointer", color: "#dc3545" }}
                      title="Remove unsaved item"
                    />
                  ) : (
                    <FaTrashAlt
                      onClick={() => deletePerformance(perf.id, idx)}
                      style={{ cursor: "pointer", color: "#dc3545" }}
                      title="Delete from database"
                    />
                  )}
                </Col>
              </Row>
            ))}
            <div className="d-flex gap-3 mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{ background: "#B31E8D" }}
                onClick={addPerformance}
              >
                Add New Key Objective
              </Button>
              <Button
                variant="outline-light"
                onClick={() => setStep(3)}
                style={{ borderColor: "#B31E8D", color: "#B31E8D" }}
              >
                Next Page
              </Button>
            </div>
          </>
        )}

        {step === 3 && (
          <>
            <p className="fw-semibold">Part III: OVERALL ASSESSMENT</p>
            <p className="fw-semibold">Summary of Ratings</p>
            <p>Overall Rating For Part I & Part II</p>

            <Row className="mb-4">
              <Col md={3}>
                {[
                  "EXCELLENT",
                  "VERY GOOD",
                  "GOOD",
                  "SATISFACTORY",
                  "BELOW AVERAGE",
                  "POOR",
                ].map((label, i) => (
                  <p key={i} className="fw-semibold">
                    {label}
                  </p>
                ))}
              </Col>
              <Col md={2}>
                {[
                  "4.5 to 5.0",
                  "4.0 to 4.49",
                  "3.5 to 3.99",
                  "3.0 to 3.49",
                  "2.5 to 2.99",
                  "< 2.5",
                ].map((score, i) => (
                  <p key={i} className="fw-semibold">
                    {score}
                  </p>
                ))}
              </Col>
              <Col md={7}>
                <p className="text-secondary small">
                  Excellent performance, well exceeded expectations. For
                  recruiters who exceed 120% of quota.
                </p>
                <p className="text-secondary small">
                  Very good performance and consistently exceed expectations.
                  For recruiters who exceed 100% -119% of quota.
                </p>
                <p className="text-secondary small">
                  Good performance and exceed expectations in many areas. For
                  recruiters who exceed 85% - 100% of quota.
                </p>
                <p className="text-secondary small">
                  Satisfactory performance, meet basic expectations and need
                  some supervision. For recruiters who achieved between 70-84%
                  of quota.
                </p>
                <p className="text-secondary small">
                  Below average performance. Needs supervision in their work.
                  Warrant P-I-P if performance remains below average for 2
                  consecutive quarters. Recruiters who meet 50% - 69% of quota.
                </p>
                <p className="text-secondary small">
                  Poor performance. Need improvement and a lot of supervision in
                  all work areas. Warrant P-I-P. Recruiters who achieved less
                  than 50% of quota for more than 2 consecutive quarters.
                </p>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-4">
              <Button
                variant="outline-light"
                size="sm"
                style={{
                  background: "#B31E8D",
                  width: "200px",
                  height: "50px",
                }}
                onClick={saveAppraisal}
              >
                Save PA Assessment
              </Button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

export default EditAppraisalAssessment;
